"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3050],{

/***/ 69247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50253);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1438);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50066);
/* harmony import */ var _Icons_BackIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2936);
/* harmony import */ var _PurchaseContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33574);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);












var StyledLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "AiPurchaseHeader__StyledLabel",
  componentId: "sc-1k1pwed-0"
})([""]);
var StyledWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
  displayName: "AiPurchaseHeader__StyledWrapper",
  componentId: "sc-1k1pwed-1"
})(["", "{display:flex;flex-direction:column;a{position:absolute;}}a{display:flex;}img{border-radius:10px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledImageText = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs(function (p) {
  return {
    variant: p.$headingLevel
  };
}).withConfig({
  displayName: "AiPurchaseHeader__StyledImageText",
  componentId: "sc-1k1pwed-2"
})(["font-size:24px;text-align:right;margin-top:", ";", "{font-size:", ";font-weight:", ";text-align:center;margin-top:0px;}"], function (p) {
  return p.$headingLevel === "h2" && "10px";
}, function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.$name ? "32px" : "50px";
}, function (p) {
  return p.$name ? "500" : "bold";
});
var StyledPriceText = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
  variant: "h3",
  component: "p"
}).withConfig({
  displayName: "AiPurchaseHeader__StyledPriceText",
  componentId: "sc-1k1pwed-3"
})(["font-family:NarkisBlock;font-size:40px;font-weight:bold;font-weight:bold;font-stretch:condensed;font-style:normal;line-height:120%;letter-spacing:normal;margin-right:0 !important;", "{font-size:50px;line-height:40px;margin-top:10px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
  displayName: "AiPurchaseHeader__StyledBox",
  componentId: "sc-1k1pwed-4"
})(["display:flex;align-items:center;position:relative;", "{margin-top:27px;}", "{display:flex;justify-content:space-between;align-items:flex-start;}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledImageWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
  displayName: "AiPurchaseHeader__StyledImageWrapper",
  componentId: "sc-1k1pwed-5"
})(["position:relative;top:-5px;", "{order:1;top:-25px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)((next_image__WEBPACK_IMPORTED_MODULE_2___default())).withConfig({
  displayName: "AiPurchaseHeader__StyledImage",
  componentId: "sc-1k1pwed-6"
})(["object-fit:cover;"]);
var StyledTextWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
  displayName: "AiPurchaseHeader__StyledTextWrapper",
  componentId: "sc-1k1pwed-7"
})(["display:flex;flex-direction:column;align-items:start;", "{order:1;margin-right:12px;align-items:right;}", "{padding-top:40px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledLine = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AiPurchaseHeader__StyledLine",
  componentId: "sc-1k1pwed-8"
})(["background:#e3e3e3;height:1px;width:50%;position:absolute;bottom:10px;"]);
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AiPurchaseHeader__StyledLink",
  componentId: "sc-1k1pwed-9"
})(["display:flex;cursor:pointer;p{margin-right:8px;}:hover{text-decoration:underline;}"]);
var StyledIconBtn = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({
  displayName: "AiPurchaseHeader__StyledIconBtn",
  componentId: "sc-1k1pwed-10"
})(["padding:1px;position:relative;bottom:2px;"]);
var StyledSchedulerText = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "AiPurchaseHeader__StyledSchedulerText",
  componentId: "sc-1k1pwed-11"
})(["font-size:16px;font-family:NarkisBlock;", "{font-size:20px;margin-top:10px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledDiscount = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "AiPurchaseHeader__StyledDiscount",
  componentId: "sc-1k1pwed-12"
})(["font-family:NarkisBlock;font-size:14px;font-weight:100;line-height:16px;letter-spacing:0em;text-align:right;", "{font-size:24px;line-height:30px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});

var AiPurchaseHeader = function AiPurchaseHeader(_ref) {
  var _giftCard$image, _giftCard$image2;

  var purchaseData = _ref.purchaseData,
      selectedMode = _ref.selectedMode,
      giftCard = _ref.giftCard,
      giftCardPrice = _ref.giftCardPrice,
      link = _ref.link,
      backIconText = _ref.backIconText,
      scrollRef = _ref.scrollRef,
      titlePrefix = _ref.titlePrefix,
      schedulerType = _ref.schedulerType,
      addPercentage = _ref.addPercentage,
      discountPrice = _ref.discountPrice;
  var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_0__/* .useIsDesktop */ .Ce)();
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();

  var _usePurchaseContext = (0,_PurchaseContext__WEBPACK_IMPORTED_MODULE_5__/* .usePurchaseContext */ .AX)(),
      videoFile = _usePurchaseContext.videoFile,
      setIsVideoApproved = _usePurchaseContext.setIsVideoApproved;

  var onGoBack = function onGoBack() {
    router.push(link);
    if (videoFile) setIsVideoApproved(true);
  };

  var getfrequencyText = function getfrequencyText() {
    var date = moment__WEBPACK_IMPORTED_MODULE_1___default()(purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.allowanceEndDateTime).format("DD/MM/YY");

    if (purchaseData.giftCardScheduleType === "Daily") {
      return "\u05DC\u05DB\u05DC \u05D9\u05D5\u05DD \u05E2\u05D3 \u05DC- ".concat(date);
    }

    if (purchaseData.giftCardScheduleType === "Weekly") {
      return "\u05DC\u05DB\u05DC \u05E9\u05D1\u05D5\u05E2 \u05E2\u05D3 \u05DC- ".concat(date);
    }

    if (purchaseData.giftCardScheduleType === "Monthly") {
      return "\u05DC\u05DB\u05DC \u05D7\u05D5\u05D3\u05E9 \u05E2\u05D3 \u05DC- ".concat(date);
    }

    if (purchaseData.giftCardScheduleType === "Yearly") {
      return "\u05DC\u05DB\u05DC \u05E9\u05E0\u05D4 \u05E2\u05D3 \u05DC- ".concat(date);
    }
  };

  var isAiImage =  true && (giftCard === null || giftCard === void 0 ? void 0 : giftCard.isAiImage) && localStorage.getItem("imageAiUrl") && (giftCard === null || giftCard === void 0 ? void 0 : giftCard.slug) === JSON.parse(localStorage.getItem("slugAi"));
  var imageUrl = isAiImage ? JSON.parse(localStorage.getItem("imageAiUrl")) : giftCard === null || giftCard === void 0 ? void 0 : (_giftCard$image = giftCard.image) === null || _giftCard$image === void 0 ? void 0 : _giftCard$image.imageUrl;
  var imageAlt = isAiImage ? "" : giftCard === null || giftCard === void 0 ? void 0 : (_giftCard$image2 = giftCard.image) === null || _giftCard$image2 === void 0 ? void 0 : _giftCard$image2.imageUrl;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledWrapper, {
    ref: scrollRef,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledLink, {
      onClick: onGoBack,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledIconBtn, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Icons_BackIcon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledLabel, {
        children: backIconText
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledBox, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledImageWrapper, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledImage, {
          src: imageUrl,
          alt: imageAlt,
          width: isDesktop ? "400px" : "188px",
          height: isDesktop ? "440px" : "136px"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledTextWrapper, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledImageText, {
          $headingLevel: "h1",
          $name: false,
          children: [titlePrefix, giftCard === null || giftCard === void 0 ? void 0 : giftCard.name]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledImageText, {
          $headingLevel: "h2",
          $name: true,
          children: selectedMode === "full" ? "\u05DC".concat(purchaseData.recipientName) : "גיפטקארד אישי"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledPriceText, {
          children: ["\u20AA", giftCardPrice]
        }), addPercentage && discountPrice && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledDiscount, {
          children: ["\u05EA\u05E9\u05DC\u05D5\u05DD \u05DC\u05D0\u05D7\u05E8 \u05D4\u05E0\u05D7\u05D4", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("span", {
            style: {
              fontWeight: "bold"
            },
            children: ["- \u20AA", discountPrice]
          })]
        }), schedulerType === "Allowance" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledSchedulerText, {
          children: getfrequencyText()
        })]
      }), isDesktop && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledLine, {})]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (AiPurchaseHeader);

/***/ }),

/***/ 53726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50253);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1438);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50066);
/* harmony import */ var _Icons_BackIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2936);
/* harmony import */ var _PurchaseContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33574);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);












var StyledLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "PurchaseHeader__StyledLabel",
  componentId: "sc-che03i-0"
})([""]);
var StyledWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
  displayName: "PurchaseHeader__StyledWrapper",
  componentId: "sc-che03i-1"
})(["", "{display:flex;flex-direction:column;margin-top:40px;a{position:absolute;}}a{display:flex;}img{border-radius:10px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledImageText = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs(function (p) {
  return {
    variant: p.$headingLevel
  };
}).withConfig({
  displayName: "PurchaseHeader__StyledImageText",
  componentId: "sc-che03i-2"
})(["font-size:24px;text-align:right;margin-top:", ";", "{font-size:", ";font-weight:", ";text-align:center;margin-top:0px;}"], function (p) {
  return p.$headingLevel === "h2" && "10px";
}, function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.$name ? "32px" : "50px";
}, function (p) {
  return p.$name ? "500" : "bold";
});
var StyledPriceText = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
  variant: "h3",
  component: "p"
}).withConfig({
  displayName: "PurchaseHeader__StyledPriceText",
  componentId: "sc-che03i-3"
})(["font-family:NarkisBlock;font-size:40px;font-weight:bold;font-weight:bold;font-stretch:condensed;font-style:normal;line-height:120%;letter-spacing:normal;margin-right:0 !important;", "{font-size:50px;line-height:40px;margin-top:10px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
  displayName: "PurchaseHeader__StyledBox",
  componentId: "sc-che03i-4"
})(["display:flex;align-items:center;position:relative;", "{margin-top:27px;}", "{display:flex;justify-content:space-between;}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledImageWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
  displayName: "PurchaseHeader__StyledImageWrapper",
  componentId: "sc-che03i-5"
})(["", "{order:1;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledTextWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
  displayName: "PurchaseHeader__StyledTextWrapper",
  componentId: "sc-che03i-6"
})(["display:flex;flex-direction:column;align-items:start;", "{order:1;margin-right:12px;align-items:right;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledLine = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PurchaseHeader__StyledLine",
  componentId: "sc-che03i-7"
})(["background:#e3e3e3;height:1px;width:50%;position:absolute;bottom:10px;"]);
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PurchaseHeader__StyledLink",
  componentId: "sc-che03i-8"
})(["display:flex;cursor:pointer;p{margin-right:8px;}:hover{text-decoration:underline;}"]);
var StyledIconBtn = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({
  displayName: "PurchaseHeader__StyledIconBtn",
  componentId: "sc-che03i-9"
})(["padding:1px;position:relative;bottom:2px;"]);
var StyledSchedulerText = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "PurchaseHeader__StyledSchedulerText",
  componentId: "sc-che03i-10"
})(["font-size:16px;font-family:NarkisBlock;", "{font-size:20px;margin-top:10px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledDiscount = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "PurchaseHeader__StyledDiscount",
  componentId: "sc-che03i-11"
})(["font-family:NarkisBlock;font-size:14px;font-weight:100;line-height:16px;letter-spacing:0em;text-align:right;", "{font-size:24px;line-height:30px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});

var PurchaseHeader = function PurchaseHeader(_ref) {
  var _giftCard$image, _giftCard$image2;

  var purchaseData = _ref.purchaseData,
      selectedMode = _ref.selectedMode,
      giftCard = _ref.giftCard,
      giftCardPrice = _ref.giftCardPrice,
      link = _ref.link,
      backIconText = _ref.backIconText,
      scrollRef = _ref.scrollRef,
      titlePrefix = _ref.titlePrefix,
      schedulerType = _ref.schedulerType,
      addPercentage = _ref.addPercentage,
      discountPrice = _ref.discountPrice;
  var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_0__/* .useIsDesktop */ .Ce)();
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();

  var _usePurchaseContext = (0,_PurchaseContext__WEBPACK_IMPORTED_MODULE_5__/* .usePurchaseContext */ .AX)(),
      videoFile = _usePurchaseContext.videoFile,
      setIsVideoApproved = _usePurchaseContext.setIsVideoApproved;

  var onGoBack = function onGoBack() {
    router.push(link);
    if (videoFile) setIsVideoApproved(true);
  };

  var getfrequencyText = function getfrequencyText() {
    var date = moment__WEBPACK_IMPORTED_MODULE_1___default()(purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.allowanceEndDateTime).format("DD/MM/YY");

    if (purchaseData.giftCardScheduleType === "Daily") {
      return "\u05DC\u05DB\u05DC \u05D9\u05D5\u05DD \u05E2\u05D3 \u05DC- ".concat(date);
    }

    if (purchaseData.giftCardScheduleType === "Weekly") {
      return "\u05DC\u05DB\u05DC \u05E9\u05D1\u05D5\u05E2 \u05E2\u05D3 \u05DC- ".concat(date);
    }

    if (purchaseData.giftCardScheduleType === "Monthly") {
      return "\u05DC\u05DB\u05DC \u05D7\u05D5\u05D3\u05E9 \u05E2\u05D3 \u05DC- ".concat(date);
    }

    if (purchaseData.giftCardScheduleType === "Yearly") {
      return "\u05DC\u05DB\u05DC \u05E9\u05E0\u05D4 \u05E2\u05D3 \u05DC- ".concat(date);
    }
  };

  var isAiImage =  true && (giftCard === null || giftCard === void 0 ? void 0 : giftCard.isAiImage) && localStorage.getItem("imageAiUrl") && (giftCard === null || giftCard === void 0 ? void 0 : giftCard.slug) === JSON.parse(localStorage.getItem("slugAi"));
  var imageUrl = isAiImage ? JSON.parse(localStorage.getItem("imageAiUrl")) : giftCard === null || giftCard === void 0 ? void 0 : (_giftCard$image = giftCard.image) === null || _giftCard$image === void 0 ? void 0 : _giftCard$image.imageUrl;
  var imageAlt = isAiImage ? "" : giftCard === null || giftCard === void 0 ? void 0 : (_giftCard$image2 = giftCard.image) === null || _giftCard$image2 === void 0 ? void 0 : _giftCard$image2.imageUrl;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledWrapper, {
    ref: scrollRef,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledLink, {
      onClick: onGoBack,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledIconBtn, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Icons_BackIcon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledLabel, {
        children: backIconText
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledBox, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledImageWrapper, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
          src: imageUrl,
          alt: imageAlt,
          width: isDesktop ? isAiImage ? "400px" : "404px" : "188px",
          height: isDesktop ? isAiImage ? "440px" : "266px" : "136px"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledTextWrapper, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledImageText, {
          $headingLevel: "h1",
          $name: false,
          children: [titlePrefix, giftCard === null || giftCard === void 0 ? void 0 : giftCard.name]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledImageText, {
          $headingLevel: "h2",
          $name: true,
          children: selectedMode === "full" ? "\u05DC".concat(purchaseData.recipientName) : "גיפטקארד אישי"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledPriceText, {
          children: ["\u20AA", giftCardPrice]
        }), addPercentage && discountPrice && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledDiscount, {
          children: ["\u05EA\u05E9\u05DC\u05D5\u05DD \u05DC\u05D0\u05D7\u05E8 \u05D4\u05E0\u05D7\u05D4", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("span", {
            style: {
              fontWeight: "bold"
            },
            children: ["- \u20AA", discountPrice]
          })]
        }), schedulerType === "Allowance" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledSchedulerText, {
          children: getfrequencyText()
        })]
      }), isDesktop && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledLine, {})]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PurchaseHeader);

/***/ }),

/***/ 43050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PaymentSteps": function() { return /* binding */ PaymentSteps; },
  "default": function() { return /* binding */ payment; }
});

// EXTERNAL MODULE: ./components/PurchasePage/Preview/Payment/BlockedPayment.tsx
var BlockedPayment = __webpack_require__(63087);
// EXTERNAL MODULE: ./components/PurchasePage/Preview/Payment/FailedPage.tsx
var FailedPage = __webpack_require__(69045);
// EXTERNAL MODULE: ./components/PurchasePage/Preview/Payment/PaymentContext.tsx
var PaymentContext = __webpack_require__(79625);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(91315);
// EXTERNAL MODULE: ./common/MediaQueries.tsx
var MediaQueries = __webpack_require__(1438);
// EXTERNAL MODULE: ./components/GenericButton/GenericButton.tsx
var GenericButton = __webpack_require__(92208);
// EXTERNAL MODULE: ./components/PurchasePage/AiPurchaseHeader.tsx
var AiPurchaseHeader = __webpack_require__(69247);
// EXTERNAL MODULE: ./components/PurchasePage/PurchaseContext.tsx
var PurchaseContext = __webpack_require__(33574);
// EXTERNAL MODULE: ./components/PurchasePage/PurchaseHeader.tsx
var PurchaseHeader = __webpack_require__(53726);
// EXTERNAL MODULE: ./components/Reusable/Functions/Functions.ts
var Functions = __webpack_require__(64416);
// EXTERNAL MODULE: ./components/Reusable/LoaderPopup.tsx
var LoaderPopup = __webpack_require__(34839);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(75741);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/PurchasePage/Preview/Payment/PaymentSchedulerText.tsx






var StyledBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "PaymentSchedulerText__StyledBox",
  componentId: "sc-15fwokk-0"
})([""]);
var StyledUl = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "PaymentSchedulerText__StyledUl",
  componentId: "sc-15fwokk-1"
})(["padding:0px;padding-right:10px;margin-bottom:20px;margin-top:0px;"]);
var StyledLi = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "PaymentSchedulerText__StyledLi",
  componentId: "sc-15fwokk-2"
})(["font-size:16px;font-family:NarkisBlock;line-height:24px;letter-spacing:0em;text-align:right;margin-top:10px;color:", ";text-align:right;::marker{color:", ";}"], colors/* default.darkGreen */.Z.darkGreen, colors/* default.yellow */.Z.yellow);

var PaymentSchedulerText = function PaymentSchedulerText(_ref) {
  var endDate = _ref.endDate,
      scheduleType = _ref.scheduleType,
      startDate = _ref.startDate;

  var getTypeText = function getTypeText() {
    var formatedDate = moment_default()(endDate).format("DD/MM/YYYY");

    if (scheduleType === "Daily") {
      return "\u05DB\u05DC \u05D9\u05D5\u05DD \u05D9\u05D9\u05E9\u05DC\u05D7 \u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05D7\u05D3\u05E9 \u05E2\u05D3 \u05DC\u05EA\u05D0\u05E8\u05D9\u05DA ".concat(formatedDate);
    }

    if (scheduleType === "Weekly") {
      return "\u05DB\u05DC \u05E9\u05D1\u05D5\u05E2 \u05D9\u05D9\u05E9\u05DC\u05D7 \u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05D7\u05D3\u05E9 \u05E2\u05D3 \u05DC\u05EA\u05D0\u05E8\u05D9\u05DA ".concat(formatedDate);
    }

    if (scheduleType === "Monthly") {
      return "\u05DB\u05DC \u05D7\u05D5\u05D3\u05E9 \u05D9\u05D9\u05E9\u05DC\u05D7 \u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05D7\u05D3\u05E9 \u05E2\u05D3 \u05DC\u05EA\u05D0\u05E8\u05D9\u05DA ".concat(formatedDate);
    }

    if (scheduleType === "Yearly") {
      return "\u05DB\u05DC \u05E9\u05E0\u05D4 \u05D9\u05D9\u05E9\u05DC\u05D7 \u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05D7\u05D3\u05E9 \u05E2\u05D3 \u05DC\u05EA\u05D0\u05E8\u05D9\u05DA ".concat(formatedDate);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledBox, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledUl, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLi, {
        children: ["\u05D4\u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05D4\u05E8\u05D0\u05E9\u05D5\u05DF \u05D9\u05D9\u05E9\u05DC\u05D7 \u05D1\u05EA\u05D0\u05E8\u05D9\u05DA ", moment_default()(startDate).format("DD/MM/YYYY")]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLi, {
        children: getTypeText()
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLi, {
        children: "\u05D4\u05D7\u05D9\u05D5\u05D1 \u05E2\u05D1\u05D5\u05E8 \u05DB\u05DC \u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05D9\u05EA\u05D1\u05E6\u05E2 \u05D1\u05E0\u05E4\u05E8\u05D3 \u05DC\u05E4\u05E0\u05D9 \u05E9\u05DC\u05D9\u05D7\u05EA\u05D5"
      })]
    })
  });
};

/* harmony default export */ var Payment_PaymentSchedulerText = (PaymentSchedulerText);
// EXTERNAL MODULE: ./components/PurchasePage/Preview/Payment/bitHelpers.ts
var bitHelpers = __webpack_require__(11966);
;// CONCATENATED MODULE: ./components/PurchasePage/Preview/Payment/PaymentIframe.tsx


























var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
  displayName: "PaymentIframe__StyledWrapper",
  componentId: "sc-1r1ypor-0"
})(["padding-right:60px;margin-top:120px;padding-left:120px;", "{margin-top:94px;padding-left:16px;padding-right:16px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledPaymentChoiceContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentIframe__StyledPaymentChoiceContainer",
  componentId: "sc-1r1ypor-1"
})(["margin-top:20px;"]);
var StyledPayments = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentIframe__StyledPayments",
  componentId: "sc-1r1ypor-2"
})(["display:flex;gap:20px;margin-top:20px;flex-direction:column;", ""], function (p) {
  return !p.$isDesktop && "justify-content: space-between;";
});
var StyledPayWithIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentIframe__StyledPayWithIcon",
  componentId: "sc-1r1ypor-3"
})(["direction:ltr;display:flex;align-items:center;font-family:Speedee,NarkisBlock,sans-serif;"]);
var StyledButtonText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "PaymentIframe__StyledButtonText",
  componentId: "sc-1r1ypor-4"
})(["text-align:right;font-family:", ";font-size:", ";font-weight:", ";font-stretch:condensed;font-style:normal;color:", ";&:hover{font-size:26px;}"], function (p) {
  return p.$bit ? "poalimBIT-Medium" : "NarkisBlock";
}, function (p) {
  return p.$bit ? "20px" : "24px";
}, function (p) {
  return p.$bit ? "500" : "bold";
}, function (p) {
  return p.$bit ? p.theme.colors.white : p.theme.colors.black;
});
var StyledDivider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentIframe__StyledDivider",
  componentId: "sc-1r1ypor-5"
})(["border-right:1px solid ", ";width:1px;height:25px;margin-left:10px;margin-right:10px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.darkGreen;
});
var StyledImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "PaymentIframe__StyledImg",
  componentId: "sc-1r1ypor-6"
})(["margin-right:", ";margin-left:", ";"], function (p) {
  return p.$bit ? "15px" : "5px";
}, function (p) {
  return p.$marginLeft ? p.$marginLeft : "5px";
});
var StyledPaymentTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "h2"
}).withConfig({
  displayName: "PaymentIframe__StyledPaymentTitle",
  componentId: "sc-1r1ypor-7"
})(["text-align:right;font-family:NarkisBlock;font-size:40px;font-weight:bold;font-stretch:condensed;font-style:normal;line-height:46px;letter-spacing:normal;"]);
var StyledPaymentSubtitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "PaymentIframe__StyledPaymentSubtitle",
  componentId: "sc-1r1ypor-8"
})(["text-align:right;line-height:26px;font-family:Speedee,NarkisBlock;font-weight:400;"]);
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(GenericButton/* default */.Z).withConfig({
  displayName: "PaymentIframe__StyledButton",
  componentId: "sc-1r1ypor-9"
})(["border:", ";background:", ";color:", ";", " ", ""], function (p) {
  return p.$isBit ? "none" : "2px solid #ffb900";
}, function (p) {
  return p.$isBit ? "linear-gradient(180deg, #2B5586 0%, #3B96B1 100%)" : p.theme.colors.white;
}, function (_ref2) {
  var theme = _ref2.theme,
      $isBit = _ref2.$isBit;
  return $isBit ? theme.colors.white : theme.colors.black;
}, function (p) {
  return p.$isBit && "border-radius: 10px;";
}, function (p) {
  return p.$isBit && "\n    &:hover {\n      background: linear-gradient(180deg, #2B5586 0%, #3B96B1 100%);\n    }\n    ";
});
var NoPaymentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentIframe__NoPaymentWrapper",
  componentId: "sc-1r1ypor-10"
})(["text-align:right;"]);
var NoPaymentSubtitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "PaymentIframe__NoPaymentSubtitle",
  componentId: "sc-1r1ypor-11"
})(["font-size:24px;line-height:30px;font-weight:400;text-align:right;"]);
var StyledTryAgainButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
  variant: "contained"
}).withConfig({
  displayName: "PaymentIframe__StyledTryAgainButton",
  componentId: "sc-1r1ypor-12"
})(["width:158px;height:48px;background-color:", ";border:none;color:", ";font-size:24px;border-radius:0px;line-height:30px;word-break:break-word;margin-top:25px;", "{width:100%;font-size:24px;}"], colors/* default.darkYellow */.Z.darkYellow, colors/* default.black */.Z.black, function (p) {
  return p.theme.breakpoints.down("sm");
});

var PaymentIframe = function PaymentIframe() {
  var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();

  var _useState = (0,react.useState)(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = (0,react.useState)(null),
      availablePayment = _useState2[0],
      setAvailablePayment = _useState2[1];

  var _usePurchaseContext = (0,PurchaseContext/* usePurchaseContext */.AX)(),
      purchaseData = _usePurchaseContext.purchaseData,
      blessingMode = _usePurchaseContext.blessingMode,
      selectedGiftCard = _usePurchaseContext.selectedGiftCard,
      giftCardLoadAmount = _usePurchaseContext.giftCardLoadAmount,
      giftCardPrice = _usePurchaseContext.giftCardPrice,
      addPercentage = _usePurchaseContext.addPercentage,
      orderId = _usePurchaseContext.orderId,
      orderRecipientGuid = _usePurchaseContext.orderRecipientGuid,
      setPaymentInitiationId = _usePurchaseContext.setPaymentInitiationId,
      setTransactionSerialId = _usePurchaseContext.setTransactionSerialId,
      schedulerType = _usePurchaseContext.schedulerType;

  var _usePaymentContext = (0,PaymentContext/* usePaymentContext */.JL)(),
      setPaymentSteps = _usePaymentContext.setPaymentSteps;

  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    if (!purchaseData || !selectedGiftCard || !orderId) router.push("/");
  }, []);
  (0,react.useEffect)(function () {
    var getPaymentTypes = /*#__PURE__*/function () {
      var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var _yield$getPaymentPaym, data;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,api.getPaymentPaymentMethods)(orderId, lib/* isChrome */.i7 ? "chrome" : lib/* isSafari */.G6 ? "safari" : lib/* isFirefox */.vU ? "firefox" : lib/* isOpera */.f0 ? "opera" : lib/* isEdge */.un ? "edge" : "other browser", null);

              case 2:
                _yield$getPaymentPaym = _context.sent;
                data = _yield$getPaymentPaym.data;
                setAvailablePayment(data.body);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getPaymentTypes() {
        return _ref3.apply(this, arguments);
      };
    }();

    getPaymentTypes();
  }, []);
  var allValuesFalse = (0,react.useMemo)(function () {
    return availablePayment && Object.values(availablePayment).every(function (value) {
      return value === false;
    });
  }, [availablePayment]);
  /**
   * This function will be called when a user selects a payment option
   *
   *
   */

  (0,react.useEffect)(function () {
    var storedData = localStorage.getItem(orderRecipientGuid);

    if (storedData) {
      var _JSON$parse = JSON.parse(storedData),
          expirationTime = _JSON$parse.expirationTime;

      var currentTime = new Date().getTime();

      if (currentTime > expirationTime) {
        localStorage.removeItem(orderRecipientGuid);
      }
    }
  }, []);

  var handlePaymentSelection = function handlePaymentSelection(paymentOption) {
    if (!paymentOption || !orderId) return;
    if (paymentOption === "creditCard") router.push("/payment/creditCard");
    if (paymentOption === "apple/google") router.push("/payment/wallet");
  };
  /**
   * Handling bit payment
   *
   *
   */


  var payBit = function payBit(transactionSerialId, paymentInitiationId) {
    (0,bitHelpers/* bitPay */.iw)({
      transactionSerialId: transactionSerialId,
      paymentInitiationId: paymentInitiationId,
      onApproval: function () {
        var _onApproval = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
          return regenerator_default().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  setLoading(true);
                  _context2.next = 4;
                  return (0,api.postPaymentPaymentDoneBit)({
                    paymentInitiationId: paymentInitiationId
                  });

                case 4:
                  setLoading(false);
                  setPaymentSteps(PaymentSteps.SUCCESS);
                  _context2.next = 13;
                  break;

                case 8:
                  _context2.prev = 8;
                  _context2.t0 = _context2["catch"](0);
                  setLoading(false);
                  setPaymentSteps(PaymentSteps.FAILURE);
                  console.log(_context2.t0);

                case 13:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 8]]);
        }));

        function onApproval() {
          return _onApproval.apply(this, arguments);
        }

        return onApproval;
      }(),
      onCancel: function () {
        var _onCancel = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
          return regenerator_default().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.prev = 0;
                  setLoading(true);
                  _context3.next = 4;
                  return (0,api.postPaymentPaymentDoneBit)({
                    paymentInitiationId: paymentInitiationId
                  });

                case 4:
                  setLoading(false);
                  _context3.next = 11;
                  break;

                case 7:
                  _context3.prev = 7;
                  _context3.t0 = _context3["catch"](0);
                  setLoading(false);
                  console.log(_context3.t0);

                case 11:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[0, 7]]);
        }));

        function onCancel() {
          return _onCancel.apply(this, arguments);
        }

        return onCancel;
      }()
    });
  };

  var getBitPayment = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
      var _yield$getPaymentGetB, data;

      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              setLoading(true);
              _context4.next = 4;
              return (0,api.getPaymentGetBit)(orderId, lib/* isChrome */.i7 ? "chrome" : lib/* isSafari */.G6 ? "safari" : lib/* isFirefox */.vU ? "firefox" : lib/* isOpera */.f0 ? "opera" : lib/* isEdge */.un ? "edge" : "other browser");

            case 4:
              _yield$getPaymentGetB = _context4.sent;
              data = _yield$getPaymentGetB.data;
              setLoading(false);

              if (!isDesktop) {
                (0,bitHelpers/* savePaymentDataToLocalStorage */.iB)(orderRecipientGuid, {
                  paymentData: data.body,
                  purchaseData: purchaseData,
                  selectedGiftCard: selectedGiftCard,
                  blessingMode: blessingMode,
                  giftCardLoadAmount: giftCardLoadAmount,
                  giftCardPrice: giftCardPrice,
                  addPercentage: addPercentage,
                  orderId: orderId,
                  orderRecipientGuid: orderRecipientGuid
                });
              }

              setTransactionSerialId(data.body.transactionSerialId);
              setPaymentInitiationId(data.body.paymentInitiationId);
              (0,bitHelpers/* loadBitCom */.ZI)({
                isDesktop: isDesktop,
                orderRecipientGuid: orderRecipientGuid,
                paymentInitiationId: data.body.paymentInitiationId,
                transactionSerialId: data.body.transactionSerialId,
                isAndroid: lib/* isAndroid */.Dt,
                isIOS: lib/* isIOS */.gn,
                pay: payBit
              });
              _context4.next = 17;
              break;

            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4["catch"](0);
              setLoading(false);
              console.log(_context4.t0);

            case 17:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 13]]);
    }));

    return function getBitPayment() {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledWrapper, {
    children: [selectedGiftCard !== null && selectedGiftCard !== void 0 && selectedGiftCard.isAiImage ? /*#__PURE__*/(0,jsx_runtime.jsx)(AiPurchaseHeader/* default */.Z, {
      purchaseData: purchaseData,
      selectedMode: blessingMode,
      giftCard: selectedGiftCard,
      giftCardPrice: purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.amount,
      link: "/preview",
      backIconText: "חזרה",
      titlePrefix: "\u05EA\u05E9\u05DC\u05D5\u05DD - ",
      schedulerType: schedulerType,
      addPercentage: addPercentage,
      discountPrice: giftCardPrice
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(PurchaseHeader/* default */.Z, {
      purchaseData: purchaseData,
      selectedMode: blessingMode,
      giftCard: selectedGiftCard,
      giftCardPrice: giftCardLoadAmount,
      link: "/preview",
      backIconText: "חזרה",
      titlePrefix: "\u05EA\u05E9\u05DC\u05D5\u05DD - ",
      schedulerType: schedulerType,
      addPercentage: addPercentage,
      discountPrice: giftCardPrice
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledPaymentChoiceContainer, {
      children: [schedulerType === "Allowance" && /*#__PURE__*/(0,jsx_runtime.jsx)(Payment_PaymentSchedulerText, {
        endDate: purchaseData.allowanceEndDateTime,
        scheduleType: purchaseData.giftCardScheduleType,
        startDate: purchaseData.allowanceStartDateTime
      }), !allValuesFalse ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledPaymentTitle, {
          children: "\u05E1\u05D9\u05DB\u05D5\u05DD \u05D4\u05E4\u05E8\u05D8\u05D9\u05DD:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPaymentSubtitle, {
          children: blessingMode === "full" ? purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.recipientName : purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.senderName
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPaymentSubtitle, {
          children: (0,Functions/* formatPhoneNumberPayment */.rv)(blessingMode === "full" ? purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.phoneNumber : purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.senderMobilePhone)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPaymentSubtitle, {
          children: blessingMode === "full" ? purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.recipientEmail : purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.senderEmail
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPaymentSubtitle, {
          children: schedulerType === "Allowance" ? "\u05D4\u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05D9\u05D9\u05E9\u05DC\u05D7 \u05D1\u05EA\u05D0\u05E8\u05D9\u05DA ".concat(moment_default()(purchaseData.allowanceStartDateTime).format("DD/MM/YYYY"), " ") : schedulerType === "Scheduled" ? "\u05D4\u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05D9\u05D9\u05E9\u05DC\u05D7 \u05D1\u05EA\u05D0\u05E8\u05D9\u05DA ".concat(moment_default()(purchaseData.messagesScheduleDate).format("DD/MM/YYYY"), " ") : " הגיפטקארד יישלח מיד לאחר התשלום"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledPayments, {
          $isDesktop: isDesktop,
          children: [(availablePayment === null || availablePayment === void 0 ? void 0 : availablePayment.creditCard) && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButton, {
            btnType: "outlined",
            onClick: function onClick() {
              return handlePaymentSelection("creditCard");
            },
            "aria-label": "\u05EA\u05E9\u05DC\u05D5\u05DD \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05DB\u05E8\u05D8\u05D9\u05E1 \u05D0\u05E9\u05E8\u05D0\u05D9",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledPayWithIcon, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledButtonText, {
                children: "\u05DB\u05E8\u05D8\u05D9\u05E1 \u05D0\u05E9\u05E8\u05D0\u05D9"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImg, {
                src: "/img/icons/CreditCardLogo.svg",
                alt: ""
              })]
            })
          }), (availablePayment === null || availablePayment === void 0 ? void 0 : availablePayment.wallet) && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButton, {
            btnType: "outlined",
            onClick: function onClick() {
              return handlePaymentSelection("apple/google");
            },
            "aria-label": "\u05EA\u05E9\u05DC\u05D5\u05DD \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05D0\u05E8\u05E0\u05E7 \u05D3\u05D9\u05D2\u05D9\u05D8\u05DC\u05D9 \u05D2\u05D5\u05D2\u05DC \u05E4\u05D9\u05D9 \u05D0\u05D5 \u05D0\u05E4\u05DC \u05E4\u05D9\u05D9",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledPayWithIcon, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledImg, {
                  src: "/img/icons/GooglePayIcon.svg",
                  alt: "",
                  $marginLeft: "0px"
                }), "Pay"]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledDivider, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledPayWithIcon, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledImg, {
                  src: "/img/icons/ApplePayIcon.svg",
                  alt: ""
                }), "Pay"]
              })]
            })
          }), (availablePayment === null || availablePayment === void 0 ? void 0 : availablePayment.bit) && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButton, {
            btnType: "outlined",
            $isBit: true,
            onClick: function onClick() {
              return getBitPayment();
            },
            "aria-label": "\u05EA\u05E9\u05DC\u05D5\u05DD \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05D1\u05D9\u05D8",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledPayWithIcon, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledImg, {
                src: "/img/icons/bitLogo.svg",
                alt: "",
                $bit: true
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledButtonText, {
                $bit: true,
                children: [" ", "\u05EA\u05E9\u05DC\u05D5\u05DD \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA"]
              })]
            })
          })]
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(NoPaymentWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledPaymentTitle, {
          children: "\u05D0\u05D5\u05E4\u05E1\u05D9, \u05D0\u05D9 \u05D0\u05E4\u05E9\u05E8 \u05DC\u05D1\u05E6\u05E2 \u05E8\u05DB\u05D9\u05E9\u05D4 \u05DB\u05E8\u05D2\u05E2 \u05D1\u05D0\u05EA\u05E8"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(NoPaymentSubtitle, {
          children: "\u05D0\u05E0\u05D7\u05E0\u05D5 \u05E2\u05DC \u05D6\u05D4! \u05D1\u05D1\u05E7\u05E9\u05D4 \u05DC\u05E0\u05E1\u05D5\u05EA \u05E9\u05D5\u05D1 \u05D1\u05E7\u05E8\u05D5\u05D1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTryAgainButton, {
          onClick: function onClick() {
            return router.push("/preview");
          },
          children: "\u05D1\u05D5\u05D0\u05D5 \u05E0\u05E0\u05E1\u05D4 \u05E9\u05D5\u05D1"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LoaderPopup/* default */.Z, {
      isOpen: loading
    })]
  });
};

/* harmony default export */ var Payment_PaymentIframe = (PaymentIframe);
// EXTERNAL MODULE: ./components/PurchasePage/Preview/Payment/SuccessPayment.tsx
var SuccessPayment = __webpack_require__(66258);
// EXTERNAL MODULE: ./components/Reusable/Loader.tsx
var Loader = __webpack_require__(83457);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/pages/payment.tsx










var ENV = "production";
var PaymentSteps;

(function (PaymentSteps) {
  PaymentSteps[PaymentSteps["PAYMENT"] = 1] = "PAYMENT";
  PaymentSteps[PaymentSteps["FAIL"] = 2] = "FAIL";
  PaymentSteps[PaymentSteps["SUCCESS"] = 3] = "SUCCESS";
  PaymentSteps[PaymentSteps["FAILURE"] = 4] = "FAILURE";
  PaymentSteps[PaymentSteps["LOADER"] = 5] = "LOADER";
  PaymentSteps[PaymentSteps["BLOCKED"] = 6] = "BLOCKED";
})(PaymentSteps || (PaymentSteps = {}));

var Payment = function Payment() {
  var _usePaymentContext = (0,PaymentContext/* usePaymentContext */.JL)(),
      paymentSteps = _usePaymentContext.paymentSteps,
      setPaymentSteps = _usePaymentContext.setPaymentSteps,
      setIframeLink = _usePaymentContext.setIframeLink;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: ENV !== "production" ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
          src: "https://ppsuat.creditguard.co.il/plugins/applePayOnIframe.js"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        src: "https://pps.creditguard.co.il/plugins/applePayOnIframe.js"
      })
    }), paymentSteps === PaymentSteps.PAYMENT && /*#__PURE__*/(0,jsx_runtime.jsx)(Payment_PaymentIframe, {}), paymentSteps === PaymentSteps.FAIL && /*#__PURE__*/(0,jsx_runtime.jsx)(FailedPage/* default */.Z, {
      title: "\u05D0\u05D5\u05D9.. \u05D7\u05D9\u05D5\u05D1 \u05D4\u05EA\u05E9\u05DC\u05D5\u05DD \u05E0\u05DB\u05E9\u05DC",
      text: "\u05E0\u05E8\u05D0\u05D4 \u05E9\u05D9\u05E9 \u05D1\u05E2\u05D9\u05D4 \u05D1\u05EA\u05E7\u05E9\u05D5\u05E8\u05EA \u05D0\u05D5 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D9 \u05D4\u05EA\u05E9\u05DC\u05D5\u05DD",
      link: "/payment",
      setPaymentSteps: setPaymentSteps,
      setIframeLink: setIframeLink
    }), paymentSteps === PaymentSteps.SUCCESS && /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessPayment/* default */.Z, {}), paymentSteps === PaymentSteps.FAILURE && /*#__PURE__*/(0,jsx_runtime.jsx)(FailedPage/* default */.Z, {
      title: "\u05D0\u05D5\u05E4\u05E1\u05D9, \u05DE\u05E9\u05D4\u05D5 \u05D4\u05E9\u05EA\u05D1\u05E9 \u05D1\u05D3\u05E8\u05DA",
      text: "\u05D0\u05DD \u05D4\u05D1\u05E2\u05D9\u05D4 \u05DE\u05DE\u05E9\u05D9\u05DB\u05D4 \u05D0\u05E4\u05E9\u05E8 \u05DC\u05E4\u05E0\u05D5\u05EA \u05DC\u05E9\u05D9\u05E8\u05D5\u05EA \u05DC\u05E7\u05D5\u05D7\u05D5\u05EA.",
      link: "/payment",
      setPaymentSteps: setPaymentSteps,
      setIframeLink: setIframeLink
    }), paymentSteps === PaymentSteps.LOADER && /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {}), paymentSteps === PaymentSteps.BLOCKED && /*#__PURE__*/(0,jsx_runtime.jsx)(BlockedPayment/* default */.Z, {})]
  });
};

/* harmony default export */ var payment = (Payment);

/***/ })

}]);